import { strCode } from "../../../../consts";

export const attributes = {
  firstName: "firstName",
  lastName: "lastName",
  email: "email",
  appType: "appType",
  markets: "markets",
  locationId: "locationId",
  name: "name",
  activeFrom: "activeFrom",
  activeTo: "activeTo",

  appTypes: "appTypes",
  roles: "roles",

  canUseIntelligentDashboards: "canUseIntelligentDashboards"
};

export const attributeNames = {
  [attributes.firstName]: strCode.FIRST_NAME_ATTR,
  [attributes.lastName]: strCode.LAST_NAME_ATTR,
  [attributes.email]: strCode.EMAIL_ATTR,
  [attributes.appType]: strCode.APPLICATION_ATTR,
  [attributes.markets]: strCode.MARKET_ATTR,
  [attributes.locationId]: strCode.LOCATION_ATTR,
  [attributes.name]: strCode.ROLE_ATTR,
  [attributes.activeFrom]: strCode.ACTIVE_FROM_ATTR,
  [attributes.activeTo]: strCode.ACTIVE_TO_ATTR,
  [attributes.appTypes]: strCode.APPLICATION_ATTR,
  [attributes.roles]: strCode.ROLE_ATTR,
  [attributes.canUseIntelligentDashboards]: strCode.SMART_DASHBOARDS
};
